import React from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "../Components/TopNavbar";
import Hero from "../Components/About/AboutHero";
import Partners from "../Components/Landingpage/Partners";
import LearningTrack from "../Components/About/LearningTrack";
import FAQs from "../Components/Landingpage/Faqs";
import Footer from "../Components/Footer"
import TalentsCompany from "../Components/Landingpage/TalentsCompany";
import OurTeam from "../Components/About/OurTeam";
import Testimonials from "../Components/Landingpage/Testimonials";
import Contact from "../Components/Landingpage/Contact";

const About = () => {
  return (
    <>
      <Helmet>
        <title>About | Innkeeper</title>
        <meta name="description" content="Learn about Innkeeper" />
      </Helmet>
      <Navbar />
      <Hero />
      <Partners />
      <LearningTrack />
      <TalentsCompany />
      <OurTeam />
      <FAQs />
      <Testimonials />
      <Contact />
      <Footer />
    </>
  );
};

export default About;
